/**
 * Agenda Toggle
 */

import { initAccordion } from '../resources/scripts/accordion';

export function initAgendaToggles(): void {
  initAccordion({ selector: '[data-agenda-toggle]' });
}
